'use strict';

var isClient = typeof window !== 'undefined';
var storage = isClient ? require('@ali/simple-storage') : {};
function isBlackList(blackList) {
  var result = false;
  Array.isArray(blackList) && blackList.forEach(function (blackItem) {
    if (isMatchOS(blackItem.os) && isMatchBrowserName(blackItem.browserName) && isMatchVersion(blackItem.versionRange)) {
      result = true;
    }
  });
  return result;
}

function isMatchOS(os) {
  var uaOS = storage.getCookie('applink_os');
  if (os) {
    if (os instanceof RegExp) {
      os = new RegExp(os.source, 'i');
    } else {
      os = new RegExp(os, 'i');
    }
    return os.test(uaOS);
  }
  return true;
}

// 对比浏览器类型
function isMatchBrowserName(browserName) {
  var uaBrowserName = storage.getCookie('applink_browser_name');
  if (browserName) {
    if (browserName instanceof RegExp) {
      browserName = new RegExp(browserName.source, 'i');
    } else {
      browserName = new RegExp(browserName, 'i');
    }
    return browserName.test(uaBrowserName);
  }
  return true;
}

// 对比版本号
function isMatchVersion(versionRange) {
  var uaBrowserVersion = storage.getCookie('applink_version');
  if (versionRange && Array.isArray(versionRange)) {
    var startVer = versionRange[0];
    var endVer = versionRange[1];

    if (startVer === '~') {
      return hasEqualCompare({ big: endVer, small: uaBrowserVersion });
    }

    if (endVer === '~') {
      return hasEqualCompare({ small: startVer, big: uaBrowserVersion });
    }

    if (startVer !== '~' && endVer !== '~') {
      return hasEqualCompare({ small: startVer, big: uaBrowserVersion }) && hasEqualCompare({
        big: endVer,
        small: uaBrowserVersion
      });
    }
  }
  return true;
}

// 判断是否有等号的比较
function hasEqualCompare(_ref) {
  var small = _ref.small,
      big = _ref.big;

  var smallVersion = small && small[0] === '=' ? small.substring(1) : small;
  var bigVersion = big && big[0] === '=' ? big.substring(1) : big;
  if (small && small[0] === '=' || big && big[0] === '=') {
    return formatVersion(smallVersion) <= formatVersion(bigVersion);
  }
  return formatVersion(smallVersion) < formatVersion(bigVersion);
}

function addZero() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var length = arguments[1];

  var padLeft = length - str.length + 1;
  padLeft = padLeft < 0 ? 0 : padLeft;
  return new Array(padLeft).join('0') + str;
}

function formatVersion() {
  var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var versionArray = version.split('.');
  for (var i = 0, j = versionArray.length; i < 6 - j; i++) {
    versionArray.push('');
  }
  return versionArray.map(function (i) {
    return addZero(i, 5);
  }).join('.');
}

module.exports = isBlackList;